import React from 'react';
import './chat.css';

const FloatingChatButton = ({ onClick }) => {
  return (
    <button className="floating-chat-button" style={{ cursor: 'all-scroll' }} onClick={onClick}>
      <div className="chatbot-div">
        <img
          src="/images/chatbot/pibot.png"
          alt="Robot Chat"
          className="chatbot-image"
        />
      </div>
      <div className="chatbot-text">
        <span className="small-text">¿Necesitas ayuda?</span>
        <span className="big-text">Hablemos</span>
      </div>
    </button>
  );
};

export default FloatingChatButton;
